import clsx from 'clsx';

interface XPostLandscapeProps {
  className?: string;
}

const XPostLandscape: React.FC<XPostLandscapeProps> = ({ className }) => {
	return (
		<svg
			className={clsx('x-post-landscape', className)}
			fill="none"
			height="124"
			viewBox="0 0 168 124"
			width="168"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect fill="white" height="123" rx="7.5" width="167" x="0.5" y="0.5" />
			<rect height="123" rx="7.5" stroke="#D1D2D4" width="167" x="0.5" y="0.5" />
			<circle cx="146" cy="10" fill="#B9BABE" r="2" />
			<circle cx="152" cy="10" fill="#B9BABE" r="2" />
			<circle cx="158" cy="10" fill="#B9BABE" r="2" />
			<rect fill="#EAEAEA" height="80" width="152" x="8" y="20" />
			<path
				d="M86.233 58.1571L94.9709 48H92.9003L85.3132 56.8193L79.2533 48H72.264L81.4277 61.3364L72.264 71.9877H74.3348L82.347 62.6742L88.7466 71.9877H95.7359L86.2325 58.1571H86.233ZM83.3968 61.4538L82.4684 60.1258L75.0809 49.5588H78.2614L84.2232 58.0867L85.1517 59.4147L92.9013 70.4998H89.7208L83.3968 61.4544V61.4538Z"
				fill="black"
			/>
			<path
				d="M12.8755 109C12.8755 106.79 14.6675 105 16.878 105H19.061C21.306 105 23.1255 106.82 23.1255 109.065C23.1255 110.545 22.322 111.905 21.0275 112.62L17.0005 114.85V113.005H16.967C14.722 113.055 12.8755 111.25 12.8755 109ZM16.878 106C15.2195 106 13.8755 107.345 13.8755 109C13.8755 110.685 15.2605 112.04 16.9445 112.005L17.12 112H18.0005V113.15L20.544 111.745C21.5195 111.205 22.1255 110.18 22.1255 109.065C22.1255 107.37 20.7535 106 19.061 106H16.878Z"
				fill="#B9BABE"
			/>
			<path
				d="M58.25 105.94L60.466 108.01L59.784 108.74L58.75 107.775V112C58.75 112.55 59.198 113 59.75 113H62.5V114H59.75C58.6455 114 57.75 113.105 57.75 112V107.775L56.716 108.74L56.034 108.01L58.25 105.94ZM64.25 107H61.5V106H64.25C65.3545 106 66.25 106.895 66.25 108V112.225L67.284 111.26L67.966 111.99L65.75 114.06L63.534 111.99L64.216 111.26L65.25 112.225V108C65.25 107.45 64.802 107 64.25 107Z"
				fill="#B9BABE"
			/>
			<path
				d="M108.348 106.75C107.737 106.72 107.009 107.005 106.403 107.83L106.001 108.375L105.598 107.83C104.992 107.005 104.263 106.72 103.652 106.75C103.03 106.785 102.477 107.14 102.197 107.705C101.921 108.265 101.88 109.095 102.436 110.115C102.973 111.1 104.065 112.25 106.001 113.42C107.936 112.25 109.027 111.1 109.564 110.115C110.119 109.095 110.079 108.265 109.802 107.705C109.522 107.14 108.969 106.785 108.348 106.75ZM110.442 110.595C109.766 111.835 108.441 113.155 106.252 114.43L106.001 114.58L105.749 114.43C103.559 113.155 102.234 111.835 101.558 110.595C100.878 109.345 100.853 108.165 101.301 107.26C101.744 106.365 102.624 105.805 103.601 105.755C104.427 105.71 105.285 106.035 106 106.76C106.715 106.035 107.573 105.71 108.398 105.755C109.375 105.805 110.255 106.365 110.699 107.26C111.147 108.165 111.122 109.345 110.442 110.595Z"
				fill="#B9BABE"
			/>
			<path
				d="M150 105.295L152.85 108.145L152.145 108.855L150.5 107.205V112H149.5V107.205L147.85 108.855L147.145 108.145L150 105.295ZM154.5 111.5L154.49 113.255C154.49 113.945 153.93 114.5 153.24 114.5H146.75C146.055 114.5 145.5 113.94 145.5 113.25V111.5H146.5V113.25C146.5 113.39 146.61 113.5 146.75 113.5H153.24C153.38 113.5 153.49 113.39 153.49 113.25L153.5 111.5H154.5Z"
				fill="#B9BABE"
			/>
		</svg>
	);
};


export default XPostLandscape;
